import api from './api'

// Minimal cart shape stored server-side (full product details are rehydrated
// client-side from these ids so prices stay current).
export interface SavedCartItem {
  product_id: number
  quantity: number
  sim_format?: 'physical' | 'esim' | null
}

export interface SavedCart {
  items: SavedCartItem[]
  referral_code: string | null
}

export const cartSyncService = {
  async getCart(): Promise<SavedCart> {
    const res = await api.get<SavedCart>('/myaccount/cart')
    return res.data
  },

  async saveCart(payload: SavedCart): Promise<void> {
    await api.put('/myaccount/cart', payload)
  },
}
